import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { trackPageView, trackVirtualPageview, trackConfiguratorStart, trackConfiguratorStep } from "utils/tracking/helpers";
import useTrackingContext from "hooks/useTrackingContext";

// Maps a route's last path segment to the configurator step it represents.
// Anything not listed here is a non-step page (model selection, saved config, ...).
const CONFIGURATOR_STEPS = {
    grade: { pageName: 'grade-selection', stepName: 'grade', stepNumber: 0 },
    select: { pageName: 'part-selection', stepName: 'select', stepNumber: 1 },
    assemble: { pageName: 'assemble', stepName: 'assemble', stepNumber: 2 },
    conclusion: { pageName: 'conclusion', stepName: 'conclusion', stepNumber: 3 },
};

const resolvePage = (pathname) => {
    const segment = pathname.split('/').filter(Boolean).pop();
    if (CONFIGURATOR_STEPS[segment]) {
        return { pageType: 'configurator', ...CONFIGURATOR_STEPS[segment] };
    }
    if (segment === 'config') {
        return { pageName: 'saved-config', pageType: 'saved-config' };
    }
    return { pageName: 'model-selection', pageType: 'model-selection' };
};

export default function TrackPageView() {
    const location = useLocation();
    const trackingContext = useTrackingContext();
    const hasFiredPageView = useRef(false);

    useEffect(() => {
        const page = resolvePage(location.pathname);
        if (!hasFiredPageView.current) {
            hasFiredPageView.current = true;
            trackPageView({ pageName: page.pageName, pageType: page.pageType, ...trackingContext });
        } else {
            trackVirtualPageview(page.pageName, page.pageType, trackingContext);
        }
        if (page.pageType === 'configurator') {
            if (page.stepNumber === 0) trackConfiguratorStart();
            trackConfiguratorStep(page.stepName, page.stepNumber);
        }
    }, [location]);
    return null;
}
